import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import Container from '@components/Container';
import { useSelector } from 'react-redux';
import ReportSidebar from './AllSidebars/ReportSidebar';
import SettingsSidebar from './AllSidebars/SettingsSidebar';
import { handleNewEventMixPanel } from '@utils/helpers';
import * as S from './styles';
import MediasSidebar from './AllSidebars/MediasSidebar';

function Sidebar({ match }) {
  const { pathname } = useLocation();
  const authenticationReducer = useSelector((state) => state.authenticationReducer);

  const [showSidebar, setShowSidebar] = useState(true);

  const trackEvent = useCallback(
    (eventName) => {
      handleNewEventMixPanel(eventName, 'view', authenticationReducer, match);
    },
    [authenticationReducer, match]
  );

  useEffect(() => {
    if (pathname.split('/').includes('Report')) {
      setShowSidebar(false);
    }

    setShowSidebar(true);
  }, [pathname]);

  const getSidebar = useMemo(() => {
    if (pathname.split('/').includes('Report')) {
      return <ReportSidebar />;
    } else if (pathname.split('/').includes('Settings')) {
      return <SettingsSidebar />;
    } else if (pathname.split('/').includes('Medias')) {
      return <MediasSidebar trackEvent={trackEvent} />;
    }
  }, [pathname, trackEvent]);

  return (
    !!getSidebar && (
      <S.SidebarWrapper showSidebar={showSidebar}>
        <Container>
          <S.LinksWrapper>{getSidebar}</S.LinksWrapper>
        </Container>
      </S.SidebarWrapper>
    )
  );
}

export default withRouter(Sidebar);
